import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, VFButton, Icon, Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  LightThemeColors,
  useTheme,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../../../Themes';

import { loadingConfig, shimmerPlaceholderConfig } from './ScanCard.LoadingConfig';
import styles from './ScanCard.styles';

const ScanCard = ({
  hideScanCardDescription,
  onPressScan,
  scanCardDescription,
  loadingConfigProp,
  shimmerPlaceholderConfigProp,
  isLoading,
}) => {
  const theme = useTheme() || LightThemeColors;
  const _images = getThemeImages(theme.name);
  if (isLoading) {
    return (
      <View style={styles.cardContainer(theme)}>
        <Shimmer
          config={loadingConfigProp}
          shimmerPlaceholderConfig={shimmerPlaceholderConfigProp}
        />
      </View>
    );
  }
  return (
    <View style={styles.cardContainer(theme)}>
      <Icon style={styles.cardIcon} name={_images.ic_bulb} type="image" size={48} />
      {!hideScanCardDescription && <VFText style={styles.cardText} i18nKey={scanCardDescription} />}
      <VFButton
        onPress={onPressScan}
        style={styles.scanButton}
        title={'payment_scan_card_button'}
      />
    </View>
  );
};
ScanCard.defaultProps = {
  hideScanCardDescription: false,
  loadingConfigProp: loadingConfig,
  shimmerPlaceholderConfigProp: shimmerPlaceholderConfig,
  onPressScan: () => {},
};
ScanCard.propTypes = {
  shimmerPlaceholderConfigProp: PropTypes.object,
  loadingConfigProp: PropTypes.array,
  scanCardDescription: PropTypes.string,
  hideScanCardDescription: PropTypes.bool,
  onPressScan: PropTypes.func,
  isLoading: PropTypes.bool,
};
export default withTheme(ScanCard);
